/**
 * MenuManagementPresenter
 * --
 */
import { useRef, useState, useEffect, useMemo } from 'react';
import {
  Content,
  Row,
  Col,
  Descriptions,
  Text,
  // Collapse,
  MenuList,
  MenuList2,
  ModalLayout,
  UploadFile,
  DragAndDrop,
  OptionForm,
} from 'components';
import { Avatar, Button, Input, Radio, Select, Flex } from 'antd';
import MessageAlert, { stringToMoneyFormat, STORE_URL } from 'utils';
import { XAxis, YAxis, BarChart, Bar, Tooltip } from 'recharts';
import { PlusSquareOutlined, MinusSquareOutlined } from '@ant-design/icons';
const MenuManagementPresenter = (props) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  const {
    menuList,
    menuData,
    // shopMenuData,
    selectedMenus,
    selectedItem,
    isEditMode,
    isOpened,
    modalData,
    modalType,
    files,
    thumbnailFiles,
    options,
    nutritionalInfo,
    groupedSelectedMenus,
    onSelectMenu,
    onSelect,
    onOpen,
    onEditMode,
    onChange,
    onSubmit,
    onFileChange,
    onThumbnailFileChange,
    onOptionList,
    onOptionChange,
    onNuritionalChange,
    onDrop,
    onUpdateOrder,
  } = props;

  // console.log('files', files);
  // console.log('data', data);
  // console.log('modaldata', modalData);
  // console.log('selectItem', selectedItem);
  // console.log(selectedMenus);
  // console.log('groupedSelectedMenus', groupedSelectedMenus);
  /* ===== STATE ===== */
  const chartRef = useRef(null);
  const [, setChartWidth] = useState(0);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  /* ===== VARIABLE ===== */

  const optionTemp = {
    option_id: 1,
    option_title: '',
    option_type: '',
    type: '',
    option: [
      {
        option_key: 1,
        option_name: '',
        option_type: '',
        option_price: 0,
        count: 0,
        default: false,
      },
    ],
  };

  /* ===== FUNCTION ===== */

  const flattenedData = (categories) => {
    const flattened = [];

    categories?.forEach((category) => {
      // 하위 카테고리가 없을 경우 상위 카테고리와 메뉴 추가
      if (!category?.subCategories?.length) {
        flattened.push({
          id: category.product_category_id,
          name: category.product_category_name,
          type: 'category',
          menus: category.menus,
        });
      } else {
        // 하위 카테고리가 있을 경우
        category?.subCategories?.forEach((subCategory) => {
          flattened.push({
            id: subCategory.product_category_id,
            name: `${category.product_category_name} > ${subCategory.product_category_name}`,
            type: 'subcategory',
            menus: subCategory.menus,
          });
        });
      }
    });

    return flattened;
  };

  /**
   * 한달치 판매량 데이터 정제
   * --
   */
  const generateSalesData = () => {
    const salesData = [];
    const today = new Date();

    for (let i = 0; i < 30; i++) {
      const date = new Date();
      date.setDate(today.getDate() - i);
      const day = `${String(date.getMonth() + 1).padStart(2, '0')}-${String(
        date.getDate()
      ).padStart(2, '0')}`;
      const sales = Math.floor(Math.random() * 5000); // 0에서 4999까지의 랜덤 판매량
      salesData.push({ day, sales });
    }

    return salesData.reverse(); // 최근 날짜가 마지막에 오도록 배열을 뒤집기
  };
  const salesStatistic = generateSalesData();

  /* ===== HOOKS ===== */
  useEffect(() => {
    const call = (e) => {
      setChartWidth(chartRef.current.clientWidth);
    };

    if (chartRef.current) call();

    window.addEventListener('resize', call);

    return () => {
      window.removeEventListener('resize', call);
    };
  }, [chartRef]);

  useEffect(() => {
    onEditMode(false, '', {});
    // eslint-disable-next-line
  }, [selectedItem]);

  const data = useMemo(() => {
    let value = menuList;
    if (searchValue) {
      value = value
        ?.map((item) => ({
          ...item,
          menus: item.menus.filter((menu) =>
            menu.menu_name.includes(searchValue)
          ),
        }))
        ?.filter((item) => item.menus.length > 0);
    }

    return value;
  }, [menuList, searchValue]);
  /* ===== RENDER ===== */
  return (
    <>
      <Content maxWidth={'100%'} padding={0}>
        <Row>
          <Col x={6}>
            <Content maxWidth={'100%'} padding={0} style={{ height: '100%' }}>
              <Content
                maxWidth={'100%'}
                padding={0}
                backgroundColor="#FAFAFA"
                style={{
                  minHeight: 800,
                  height: '100%',
                  overflow: 'auto',
                  borderRight: '1px solid #F0F0F0',
                  position: 'relative',
                  top: 0,
                  left: 0,
                }}
              >
                <Content maxWidth={'100%'} padding={8}>
                  {/* <Button
                    style={{ ...styles.button }}
                    onClick={() => onOpen(isOpened, 'category')}
                  >
                    카테고리 신청
                  </Button> */}

                  {/* <Button
                    type="primary"
                    style={{ ...styles.button }}
                    onClick={() => onOpen(isOpened, 'menu')}
                  >
                    메뉴 신청
                  </Button> */}
                </Content>
                <Content maxWidth={'100%'} padding={8} backgroundColor="none">
                  <Flex vertical gap={5}>
                    <Button
                      style={{
                        width: '100%',
                        height: 32,
                        fontSize: 13,
                        fontWeight: 500,
                      }}
                      onClick={() => onOpen(isOpened, 'shopmenu')}
                    >
                      매장 메뉴 추가/편집
                    </Button>
                    <Input
                      value={searchValue}
                      onChange={(e) => setSearchValue(e.target.value)}
                      placeholder="메뉴 검색 *순서편집시에는 검색어를 삭제해주세요."
                    />
                  </Flex>
                </Content>
                <Content
                  maxWidth={'100%'}
                  padding={8}
                  backgroundColor="none"
                  style={{
                    maxHeight: 800,
                    overflow: 'scroll',
                    marginBottom: 45,
                  }}
                >
                  {data?.map((category) => (
                    <div
                      key={`category_${category?.product_category_id}`}
                      style={{ marginBottom: '20px' }}
                    >
                      {/* 상위 카테고리 */}
                      <MenuList
                        title={category?.product_category_name}
                        data={category}
                        onMenuSelect={onSelect}
                        selectedItem={selectedItem}
                      />
                    </div>
                  ))}
                  {/* {data?.map((category) => (
                    <Collapse
                      key={`category_${category?.product_category_id}`}
                      title={category?.product_category_name}
                      defaultOpened
                    >
                      {category.subCategories?.length > 0
                        ? category.subCategories.map((subCategory) => (
                            <div
                              key={`subcategory_wrapper_${subCategory?.product_category_id}`}
                              style={{
                                marginLeft: '5%', // 하위 카테고리 들여쓰기
                                backgroundColor: '#f7f7f7', // 하위 카테고리 배경색 설정
                              }}
                            >
                              <Collapse
                                key={`subcategory_${subCategory?.product_category_id}`}
                                title={
                                  <span style={{ paddingLeft: '20px' }}>
                                    {subCategory?.product_category_name}
                                  </span>
                                }
                                defaultOpened
                              >
                                {subCategory?.menus?.map((menu) => (
                                  <div
                                    key={`menu_${menu?.menu_id}`}
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      padding: 8,
                                      cursor: 'pointer',
                                      border:
                                        selectedItem?.menu_id === menu?.menu_id
                                          ? '1px solid #2394E4'
                                          : '1px solid #EFEFEF',
                                      borderBottom:
                                        selectedItem?.menu_id === menu?.menu_id
                                          ? '1px solid #2394E4'
                                          : '1px solid #DFDFDF',
                                      background:
                                        selectedItem?.menu_id === menu?.menu_id
                                          ? 'rgba(28, 107, 244, 0.3)'
                                          : '#EFEFEF',
                                    }}
                                    onClick={() => onSelect(menu)}
                                  >
                                    <div>
                                      <Avatar shape="square" size={30} />
                                    </div>
                                    <div style={{ paddingLeft: 7 }}>
                                      <h4>{menu?.menu_name}</h4>
                                      <p>
                                        {stringToMoneyFormat(menu?.price, '원')}
                                      </p>
                                    </div>
                                  </div>
                                ))}
                              </Collapse>
                            </div>
                          ))
                        : // 상위 카테고리 메뉴
                          category?.menus?.map((menu) => (
                            <div
                              key={`menu_${menu?.menu_id}`}
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                padding: 8,
                                cursor: 'pointer',
                                border:
                                  selectedItem?.menu_id === menu?.menu_id
                                    ? '1px solid #2394E4'
                                    : '1px solid #EFEFEF',
                                borderBottom:
                                  selectedItem?.menu_id === menu?.menu_id
                                    ? '1px solid #2394E4'
                                    : '1px solid #DFDFDF',
                                background:
                                  selectedItem?.menu_id === menu?.menu_id
                                    ? 'rgba(28, 107, 244, 0.3)'
                                    : '#EFEFEF',
                              }}
                              onClick={() => onSelect(menu)}
                            >
                              <div>
                                <Avatar shape="square" size={30} />
                              </div>
                              <div style={{ paddingLeft: 7 }}>
                                <h4>{menu?.menu_name}</h4>
                                <p>{stringToMoneyFormat(menu?.price, '원')}</p>
                              </div>
                            </div>
                          ))}
                    </Collapse>
                  ))} */}
                </Content>
                <Content
                  maxWidth={'100%'}
                  padding={8}
                  backgroundColor="none"
                  style={{ position: 'absolute', bottom: 0, left: 0 }}
                >
                  <Button
                    style={{
                      width: '100%',
                      height: 32,
                      fontSize: 13,
                      fontWeight: 500,
                    }}
                    onClick={() => onOpen(isOpened, 'order')}
                  >
                    순서편집
                  </Button>
                </Content>
              </Content>
            </Content>
          </Col>
          <Col x={18}>
            <Content maxWidth={'100%'} padding={20}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: 10,
                }}
              >
                <Text size={14} weight={600} color={'#404040'}>
                  메뉴정보
                </Text>
                <div>
                  <Button
                    type="primary"
                    style={{ background: 'var(--primary-color)', width: 73 }}
                    onClick={() => {
                      if (!selectedItem?.menu_id) {
                        MessageAlert.warning(
                          '선택된 메뉴가 없습니다. 편집할 메뉴를 선택해주세요.'
                        );
                        return;
                      } else if (isEditMode) {
                        onSubmit('SHOPMENUEDIT', 'UPDATE');
                      } else {
                        onEditMode(true, 'menu', {
                          shop_menu_id: selectedItem?.shop_menu_id,
                          num: selectedItem?.num,
                          is_offline: selectedItem?.is_offline,
                        });
                      }
                    }}
                  >
                    {isEditMode ? '저장' : '편집'}
                  </Button>
                  {isEditMode ? (
                    <>
                      <Button
                        style={{ width: 73 }}
                        onClick={() => {
                          onEditMode(false, '', {});
                        }}
                      >
                        취소
                      </Button>
                    </>
                  ) : (
                    ''
                  )}
                </div>
              </div>
              <Descriptions
                align="left"
                column={3}
                items={[
                  {
                    key: 'menu_name',
                    label: '메뉴명',
                    children: selectedItem?.menu_name || '-',
                  },
                  {
                    key: 'menu_code',
                    label: '메뉴번호',
                    children: selectedItem?.menu_id || '-',
                  },
                  {
                    key: 'price',
                    label: '단가',
                    children: selectedItem?.price
                      ? stringToMoneyFormat(selectedItem.price, '원')
                      : '-',
                  },
                  {
                    key: 'menu_content',
                    label: '메뉴 설명',
                    children: selectedItem?.menu_content || '-',
                    span: 3,
                  },
                  {
                    key: 'num',
                    label: '메뉴 수량',
                    children: isEditMode ? (
                      <Input
                        size="large"
                        value={
                          isEditMode ? modalData?.menu?.num : selectedItem?.num
                        }
                        onChange={(e) => {
                          const numericValue = parseInt(e.target.value, 10);
                          onChange(
                            'num',
                            isNaN(numericValue) ? 0 : numericValue,
                            'menu'
                          );
                        }}
                      />
                    ) : (
                      selectedItem?.num || '-'
                    ),
                    span: 1,
                  },
                  {
                    key: 'is_offline',
                    label: '대면 판매 여부',
                    children: isEditMode ? (
                      <Radio.Group
                        options={[
                          { label: '대면 판매', value: 'Y' },
                          { label: '전체 판매', value: 'N' },
                        ]}
                        onChange={(e) =>
                          onChange('is_offline', e.target.value, 'menu')
                        }
                        value={
                          isEditMode
                            ? modalData?.menu?.is_offline
                            : selectedItem?.is_offline
                        }
                        optionType="button"
                        buttonStyle="solid"
                      />
                    ) : selectedItem?.is_offline === 'Y' ? (
                      '대면 판매'
                    ) : (
                      '전체 판매'
                    ),
                    span: 2,
                  },
                  {
                    key: 'temperature_option',
                    label: '온도 옵션',
                    children:
                      selectedItem?.temperature_option === 'ALL'
                        ? 'HOT / ICE'
                        : selectedItem?.temperature_option === 'HOT'
                        ? 'HOT ONLY'
                        : selectedItem?.temperature_option === 'ICE'
                        ? 'ICE ONLY'
                        : selectedItem?.temperature_option || '-',
                  },
                  {
                    key: 'type',
                    label: '메뉴 타입',
                    children:
                      selectedItem?.type === 'MD'
                        ? 'MD상품'
                        : selectedItem?.type === 'DESSERT'
                        ? '디저트'
                        : selectedItem?.type === 'ALC'
                        ? '주류'
                        : selectedItem?.type === 'ETC'
                        ? '기타'
                        : '일반',
                  },
                  {
                    key: 'is_show',
                    label: '노출 여부',
                    children: selectedItem?.is_show || '-',
                  },
                  {
                    key: 'menu_option',
                    label: '기타 옵션',
                    children:
                      selectedItem?.menu_option?.map((option, index) => (
                        <div
                          key={`option_${index}`}
                          style={{
                            padding: '10px 20px',
                            borderBottom:
                              index === selectedItem.menu_option.length - 1
                                ? 'none'
                                : '1px solid rgba(112, 115, 124, 0.2)',
                          }}
                        >
                          <Text size={13} weight={600} color={'#454545'}>
                            {option.option_title || 'Option'}
                          </Text>
                          <Radio.Group style={{ marginTop: 8 }} value="">
                            {option.option.map((optItem) => (
                              <Radio
                                key={`item_${optItem.option_key}`}
                                value={optItem}
                              >
                                {optItem.option_name || 'Option Name'}
                              </Radio>
                            ))}
                          </Radio.Group>
                        </div>
                      )) || '-',
                    span: 3,
                    style: { padding: 0 },
                  },
                  {
                    key: 'nutritional_information',
                    label: '영양 정보',
                    children:
                      selectedItem?.nutritional_information?.map(
                        (info, index) => (
                          <div
                            key={`nutritional_info_${index}`}
                            style={{ marginBottom: 10 }}
                          >
                            <Text size={13} weight={600} color={'#454545'}>
                              {info.nutritional_title}:{' '}
                              {info.nutritional_amount}
                              {info.nutritional_type}
                            </Text>
                          </div>
                        )
                      ) || '-',
                    span: 3,
                  },
                  {
                    key: 'allergen_ingredient',
                    label: '알레르기 유발 성분',
                    children: selectedItem?.allergen_ingredient || '-',
                    span: 3,
                  },
                  {
                    key: 'exchange_return_policy',
                    label: '교환/반품 안내',
                    children: selectedItem?.exchange_return_policy || '-',
                    span: 3,
                  },
                  {
                    key: 'is_present',
                    label: '선물 가능 여부',
                    children:
                      selectedItem?.is_present === 'Y'
                        ? '선물 가능'
                        : '선물 불가',
                    span: 3,
                  },
                  {
                    key: 'present_information',
                    label: '선물 관련 정보',
                    children: selectedItem?.present_information ? (
                      <div>
                        <div>
                          <strong>유효기간:</strong>{' '}
                          {
                            selectedItem.present_information
                              .present_expired_date
                          }
                          일
                        </div>
                        <div>
                          <strong>최대 연장 횟수:</strong>{' '}
                          {
                            selectedItem.present_information
                              .present_postponed_deadline
                          }
                          회
                        </div>
                      </div>
                    ) : (
                      '-'
                    ),
                    span: 3,
                  },
                  {
                    key: 'menu_file',
                    label: '이미지',
                    children: (
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          flexWrap: 'wrap',
                          padding: '20px 0px',
                        }}
                      >
                        {selectedItem?.menu_file
                          ?.filter((file) => file.type === 'THUMBNAIL')
                          ?.map((file, index) => (
                            <Avatar
                              key={`img_${index}`}
                              size={100}
                              shape="square"
                              style={{ marginRight: 10 }}
                              src={`${STORE_URL}/${file.file_url}`}
                            />
                          )) || '-'}
                        {selectedItem?.menu_file
                          ?.filter((file) => file.type !== 'THUMBNAIL')
                          ?.map((file, index) => (
                            <Avatar
                              key={`img_${index}`}
                              size={100}
                              shape="square"
                              style={{ marginRight: 10 }}
                              src={`${STORE_URL}/${file.file_url}`}
                            />
                          )) || '-'}
                      </div>
                    ),
                    span: 3,
                  },
                  {
                    key: `7`,
                    label: '매출',
                    children: (
                      <div style={{ padding: '20px 0px' }}>
                        <ul
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                          }}
                        >
                          <li
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              paddingRight: 40,
                            }}
                          >
                            <span
                              style={{
                                width: 5,
                                height: 36,
                                background: '#0F6CBD',
                                marginRight: 5,
                              }}
                            ></span>
                            <div>
                              <Text
                                size={12}
                                color={'#424242'}
                                style={{ lineHeight: 1.25 }}
                              >
                                매출
                              </Text>
                              <Text
                                size={16}
                                weight={600}
                                color={'#424242'}
                                style={{ lineHeight: 1.25 }}
                              >
                                0원
                              </Text>
                            </div>
                          </li>
                          <li
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                            }}
                          >
                            <span
                              style={{
                                width: 5,
                                height: 36,
                                background: '#C50F1F',
                                marginRight: 5,
                              }}
                            ></span>
                            <div>
                              <Text
                                size={12}
                                color={'#424242'}
                                style={{ lineHeight: 1.25 }}
                              >
                                판매비율
                              </Text>
                              <Text
                                size={16}
                                weight={600}
                                color={'#424242'}
                                style={{ lineHeight: 1.25 }}
                              >
                                0%
                              </Text>
                            </div>
                          </li>
                        </ul>
                        <div ref={chartRef} style={{ marginTop: 20 }}>
                          <BarChart
                            width={
                              // chartWidth
                              []
                            }
                            height={300}
                            data={salesStatistic}
                          >
                            <XAxis
                              dataKey={'day'}
                              stroke="#686C73"
                              // tickFormatter={(d) => moment(d).format('MM-DD')}
                            />
                            <YAxis stroke="#686C73" />
                            <Tooltip />
                            <Bar
                              dataKey={'sales'}
                              fill={'var(--primary-color)'}
                            />
                          </BarChart>
                        </div>
                      </div>
                    ),
                    span: 3,
                  },
                ]}
              />
            </Content>
          </Col>
        </Row>
      </Content>

      {/* 카테고리 신청 */}
      <ModalLayout
        type="modal"
        centered
        title={'카테고리 신청'}
        open={isOpened && modalType === 'category'}
        onCancel={() => onOpen(isOpened)}
        closable
        width={500}
        footer={
          <Content
            maxWidth={'100%'}
            padding={0}
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Button onClick={() => onOpen(isOpened)}>닫기</Button>
            <Button
              type="primary"
              onClick={() => onSubmit('category', 'CREATE')}
            >
              저장
            </Button>
          </Content>
        }
      >
        <Content maxWidth={'100%'} padding={'30px 0px'}>
          <Row>
            <Col x={24}>
              <Content maxWidth={'100%'} padding={0}>
                <div style={{ marginBottom: '20px' }}>
                  <Select
                    size="large"
                    style={{ width: '100%' }}
                    placeholder="상위 카테고리 선택 (선택사항)"
                    value={modalData?.category?.parents_id}
                    onChange={(value) =>
                      onChange('parents_id', value, 'category')
                    }
                    options={[
                      { label: '상위 카테고리 없음', value: null },
                      ...(Array.isArray(menuData)
                        ? menuData
                            .filter(
                              (category) =>
                                !category.menus || category.menus.length === 0
                            ) // 메뉴가 없는 카테고리만 필터링
                            .map((category) => ({
                              label: category.product_category_name,
                              value: category.product_category_id,
                            }))
                        : []), // data가 배열이 아닐 때 빈 배열로 처리
                    ]}
                  />
                </div>

                <div>
                  <Input
                    size="large"
                    count={{
                      show: true,
                      max: 30,
                    }}
                    placeholder="카테고리를 입력해주세요"
                    value={modalData?.category?.product_category_name}
                    onChange={(e) =>
                      onChange(
                        'product_category_name',
                        e.target.value,
                        'category'
                      )
                    }
                  />
                </div>
              </Content>
            </Col>
          </Row>
        </Content>
      </ModalLayout>

      {/* 매장 메뉴 추가/편집 */}
      <ModalLayout
        type="modal"
        centered
        title={'매장 메뉴 추가/편집'}
        open={isOpened && modalType === 'shopmenu'}
        onCancel={() => onOpen(isOpened)}
        closable
        width={800} // 모달 너비를 넓게 조정
        footer={
          <Content
            maxWidth={'100%'}
            padding={0}
            style={{
              display: 'flex', // 좌우 레이아웃을 위해 flex 사용
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Button onClick={() => onOpen(isOpened)}>닫기</Button>
            <Button type="primary" onClick={() => onSubmit('shopmenu')}>
              저장
            </Button>
          </Content>
        }
      >
        <Content
          maxWidth={'100%'}
          padding={8}
          backgroundColor="none"
          style={{
            display: 'flex', // 좌우 레이아웃을 위해 flex 사용
            maxHeight: 800,
            overflow: 'scroll',
            marginBottom: 45,
          }}
        >
          {/* 왼쪽: 메뉴 목록 */}
          <div style={{ flex: 1, marginRight: 16 }}>
            {menuData?.map((category) => (
              <div
                key={`category_${category?.product_category_id}`}
                style={{ marginBottom: '20px' }}
              >
                <MenuList2
                  title={category?.product_category_name}
                  data={category}
                  onMenuSelect={(menu) =>
                    onSelectMenu(
                      menu,
                      category?.subCategories?.find(
                        (sub) =>
                          sub.product_category_id === menu.product_category_id
                      )?.product_category_name,
                      category?.subCategories?.find(
                        (sub) =>
                          sub.product_category_id === menu.product_category_id
                      )?.parents_id,
                      category?.product_category_name
                    )
                  }
                  selectedMenus={selectedMenus} // selectedMenus 전체 전달
                />
              </div>
            ))}

            {/* {menuData?.map((category) => (
              <Collapse
                key={`category_${category?.product_category_id}`}
                title={category?.product_category_name}
                defaultOpened
                titleStyle={{
                  fontWeight: 500,
                  color: '#4A4A4A',
                  background: '#D4D4D4',
                  overflow: 'scroll',
                }}
              >
                {category.subCategories?.length > 0
                  ? category.subCategories.map((subCategory) => (
                      <div
                        key={`subcategory_wrapper_${subCategory?.product_category_id}`}
                        style={{
                          marginLeft: '5%', // 하위 카테고리 들여쓰기
                          backgroundColor: '#f7f7f7', // 하위 카테고리 배경색 설정
                        }}
                      >
                        <Collapse
                          key={`subcategory_${subCategory?.product_category_id}`}
                          title={
                            <span style={{ paddingLeft: '20px' }}>
                              {subCategory?.product_category_name}
                            </span>
                          }
                          defaultOpened
                        >
                          {subCategory?.menus?.map((menu) => (
                            <div
                              key={`menu_${menu?.menu_id}`}
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                padding: 8,
                                cursor: 'pointer',
                                border: selectedMenus?.some(
                                  (item) => item.menu_id === menu?.menu_id
                                )
                                  ? '1px solid #2394E4'
                                  : '1px solid #EFEFEF',
                                borderBottom: selectedMenus?.some(
                                  (item) => item.menu_id === menu?.menu_id
                                )
                                  ? '1px solid #2394E4'
                                  : '1px solid #DFDFDF',
                                background: selectedMenus?.some(
                                  (item) => item.menu_id === menu?.menu_id
                                )
                                  ? 'rgba(28, 107, 244, 0.3)'
                                  : '#EFEFEF',
                              }}
                              onClick={() =>
                                onSelectMenu(
                                  menu,
                                  subCategory?.product_category_name,
                                  subCategory?.parents_id,
                                  category?.product_category_name
                                )
                              }
                            >
                              <div>
                                <Avatar shape="square" size={30} />
                              </div>
                              <div style={{ paddingLeft: 7 }}>
                                <h4>{menu?.menu_name}</h4>
                                <p>{stringToMoneyFormat(menu?.price, '원')}</p>
                              </div>
                            </div>
                          ))}
                        </Collapse>
                      </div>
                    ))
                  : // 상위 카테고리 메뉴
                    category?.menus?.map((menu) => (
                      <div
                        key={`menu_${menu?.menu_id}`}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          padding: 8,
                          cursor: 'pointer',
                          border: selectedMenus?.some(
                            (item) => item.menu_id === menu?.menu_id
                          )
                            ? '1px solid #2394E4'
                            : '1px solid #EFEFEF',
                          borderBottom: selectedMenus?.some(
                            (item) => item.menu_id === menu?.menu_id
                          )
                            ? '1px solid #2394E4'
                            : '1px solid #DFDFDF',
                          background: selectedMenus?.some(
                            (item) => item.menu_id === menu?.menu_id
                          )
                            ? 'rgba(28, 107, 244, 0.3)'
                            : '#EFEFEF',
                        }}
                        onClick={() =>
                          onSelectMenu(
                            menu,
                            null,
                            null,
                            category?.product_category_name
                          )
                        }
                      >
                        <div>
                          <Avatar shape="square" size={30} />
                        </div>
                        <div style={{ paddingLeft: 7 }}>
                          <h4>{menu?.menu_name}</h4>
                          <p>{stringToMoneyFormat(menu?.price, '원')}</p>
                        </div>
                      </div>
                    ))}
              </Collapse>
            ))} */}
          </div>

          {/* 오른쪽: 선택된 메뉴 표시 */}
          <div style={{ flex: 1 }}>
            <Text
              size={14}
              weight={700}
              color={'#4E4E4E'}
              style={{ marginBottom: 8 }}
            >
              선택된 메뉴
            </Text>
            {selectedMenus?.length > 0 ? (
              Object.entries(groupedSelectedMenus).map(
                ([parentCategoryName, categoryData]) => (
                  <MenuList
                    key={`selected_category_${parentCategoryName}`}
                    title={`${parentCategoryName}`}
                    data={{
                      menus: categoryData.menus,
                      subCategories: Object.entries(
                        categoryData.subCategories
                      ).map(([subCategoryName, subCategoryMenus]) => ({
                        product_category_name: subCategoryName,
                        menus: subCategoryMenus,
                      })),
                    }}
                    onMenuSelect={onSelectMenu}
                    // selectedItem={selectedMenus?.find((item) =>
                    //   categoryData.menus.some(
                    //     (menu) => menu.menu_id === item.menu_id
                    //   )
                    // )}
                  />
                )
              )
            ) : (
              <Text size={14} weight={400} color={'#4E4E4E'}>
                선택된 메뉴가 없습니다.
              </Text>
            )}
          </div>
        </Content>
      </ModalLayout>

      {/* 순서 편집 */}
      <ModalLayout
        type="modal"
        centered
        title={'메뉴 순서 편집'}
        open={isOpened && modalType === 'order'}
        onCancel={() => onOpen(isOpened)}
        closable
        width={600}
        footer={
          <Content
            maxWidth={'100%'}
            padding={0}
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Button onClick={() => onOpen(isOpened)}>닫기</Button>
            <Button type="primary" onClick={() => onUpdateOrder()}>
              저장
            </Button>
          </Content>
        }
      >
        <Content maxWidth={'100%'} padding={'30px 0px'}>
          <Row>
            <Col x={24}>
              <Content maxWidth={'100%'} padding={0}>
                {flattenedData(data).map((item) => (
                  <div key={`category_${item.id}`}>
                    {/* 카테고리 렌더링 */}
                    <Flex
                      justify={'space-between'}
                      style={{
                        padding: '8px 16px',
                        backgroundColor: '#F5F5F5',
                        border: '1px solid #EFEFEF',
                        marginBottom: '8px',
                      }}
                    >
                      <Text size={14} weight={700}>
                        {item.name}
                      </Text>
                      <Button
                        size="small"
                        type="text"
                        style={{ padding: 0, margin: 0 }}
                        onClick={() => {
                          setSelectedCategories((prev) =>
                            selectedCategories?.includes(item.id)
                              ? prev.filter((id) => id !== item.id)
                              : [...prev, item.id]
                          );
                        }}
                      >
                        {selectedCategories?.includes(item.id) ? (
                          <MinusSquareOutlined style={{ fontSize: '1.25em' }} />
                        ) : (
                          <PlusSquareOutlined style={{ fontSize: '1.25em' }} />
                        )}
                      </Button>
                    </Flex>
                    {/* 메뉴 드래그 앤 드롭 */}
                    {item.menus.length > 0 &&
                      selectedCategories?.includes(item.id) && (
                        <DragAndDrop
                          items={item.menus}
                          parentId={item.id} // 상위 카테고리 ID 전달
                          onDrop={(updatedItems) =>
                            onDrop(updatedItems, 1, item.id)
                          }
                          render={(menu) => (
                            <div
                              key={`menu_${menu.menu_id}`}
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                padding: '8px 16px',
                                cursor: 'pointer',
                                border: '1px solid #EFEFEF',
                                marginBottom: '4px',
                                background: '#FFFFFF',
                              }}
                            >
                              <Avatar shape="square" size={30} />
                              <div style={{ paddingLeft: '8px' }}>
                                <Text size={12} weight={600}>
                                  {menu.menu_name}
                                </Text>
                                <Text size={11} color="#6D6D6D">
                                  {stringToMoneyFormat(menu.price, '원')}
                                </Text>
                              </div>
                            </div>
                          )}
                        />
                      )}
                  </div>
                ))}
              </Content>
            </Col>
          </Row>
        </Content>
      </ModalLayout>

      {/* 메뉴 신청 */}
      <ModalLayout
        type="modal"
        centered
        title={'메뉴 신청'}
        open={isOpened && modalType === 'menu'}
        onCancel={() => onOpen(isOpened)}
        closable
        width={'60%'}
        footer={
          <Content
            maxWidth={'100%'}
            padding={0}
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: 10,
            }}
          >
            <Button onClick={() => onOpen(isOpened)}>닫기</Button>
            <Button
              type="primary"
              onClick={() =>
                onSubmit('menu', modalData?.menu?.menu_id ? 'UPDATE' : 'CREATE')
              }
            >
              신청
            </Button>
          </Content>
        }
      >
        <Content maxWidth={'100%'} padding={'30px 0px'}>
          <Row>
            <Col x={24}>
              <Content maxWidth={'100%'} padding={0}>
                <Descriptions
                  items={[
                    {
                      key: 'menu_name',
                      label: '메뉴명',
                      children: (
                        <Input
                          size="large"
                          count={{
                            show: true,
                            max: 30,
                          }}
                          value={modalData?.menu?.menu_name}
                          placeholder="메뉴명을 입력해주세요"
                          onChange={(e) =>
                            onChange('menu_name', e.target.value, 'menu')
                          }
                        />
                      ),
                    },
                    {
                      key: 'price',
                      label: '단가',
                      children: (
                        <Input
                          size="large"
                          placeholder="금액을 입력해주세요"
                          value={modalData?.menu?.price}
                          onChange={(e) => {
                            const numericValue = parseInt(e.target.value, 10);
                            onChange(
                              'price',
                              isNaN(numericValue) ? 0 : numericValue,
                              'menu'
                            );
                          }}
                        />
                      ),
                    },
                    {
                      key: 'category',
                      label: '카테고리',
                      children: (
                        <div style={{ display: 'flex' }}>
                          <Select
                            size="large"
                            placeholder="카테고리를 선택해주세요"
                            value={modalData?.menu?.product_category_id}
                            onChange={(value) =>
                              onChange('product_category_id', value, 'menu')
                            }
                            options={data?.reduce((acc, category) => {
                              // subCategories가 있는 경우에는 그 하위 카테고리들을 보여준다
                              if (
                                category.subCategories &&
                                category.subCategories.length > 0
                              ) {
                                // 상위카테고리 > 하위카테고리 형식으로 subCategories를 추가
                                category.subCategories.forEach(
                                  (subCategory) => {
                                    const parentCategory =
                                      category.product_category_name;
                                    acc.push({
                                      label: `${parentCategory} > ${subCategory.product_category_name}`,
                                      value: subCategory.product_category_id,
                                    });
                                  }
                                );
                              } else {
                                // subCategories가 없는 상위 카테고리만 추가
                                acc.push({
                                  label: category.product_category_name,
                                  value: category.product_category_id,
                                });
                              }
                              return acc;
                            }, [])} // 빈 배열을 초기값으로 하여 각 카테고리를 축적
                          />
                        </div>
                      ),
                    },
                    {
                      key: 'type',
                      label: '메뉴 타입',
                      children: (
                        <Radio.Group
                          options={[
                            { label: '디저트', value: 'DESSERT' },
                            { label: 'MD', value: 'MD' },
                            { label: '일반', value: 'GENERAL' },
                            { label: '주류', value: 'ALC' },
                            { label: '기타', value: 'ETC' },
                          ]}
                          onChange={(e) =>
                            onChange('type', e.target.value, 'menu')
                          }
                          value={modalData?.menu?.type}
                          optionType="button"
                          buttonStyle="solid"
                        />
                      ),
                    },
                    {
                      key: 'is_show',
                      label: '노출 여부',
                      span: 2,
                      children: (
                        <Radio.Group
                          options={[
                            { label: '노출 안함', value: 'N' },
                            { label: '노출', value: 'Y' },
                          ]}
                          onChange={(e) =>
                            onChange('is_show', e.target.value, 'menu')
                          }
                          value={modalData?.menu?.is_show}
                          optionType="button"
                          buttonStyle="solid"
                        />
                      ),
                    },
                    {
                      key: 'sub_menu_name',
                      label: '서브메뉴명',
                      span: 2,
                      children: (
                        <Input
                          size="large"
                          value={modalData?.menu?.sub_menu_name}
                          placeholder="서브메뉴명을 입력해주세요"
                          onChange={(e) =>
                            onChange('sub_menu_name', e.target.value, 'menu')
                          }
                        />
                      ),
                    },
                    {
                      key: 'menu_content',
                      label: '설명',
                      span: 2,
                      children: (
                        <div style={{ padding: '20px 0px' }}>
                          <Input.TextArea
                            size="large"
                            placeholder="설명을 입력해주세요"
                            count={{
                              show: true,
                              max: 200,
                            }}
                            style={{ minHeight: 78 }}
                            value={modalData?.menu?.menu_content}
                            onChange={(e) =>
                              onChange('menu_content', e.target.value, 'menu')
                            }
                          />
                        </div>
                      ),
                    },
                    {
                      key: 'nutritional_information',
                      label: '영양 정보',
                      span: 2,
                      children: (
                        <div style={{ padding: '20px 0px' }}>
                          {(nutritionalInfo || []).map((info, index) => (
                            <div
                              key={`nutritional_info_${index}`}
                              style={{ marginBottom: 10 }}
                            >
                              <Input
                                placeholder="영양정보명"
                                value={info.nutritional_title}
                                onChange={(e) =>
                                  onNuritionalChange(
                                    'update',
                                    { nutritional_title: e.target.value },
                                    index
                                  )
                                }
                                style={{ width: '30%', marginRight: '5px' }}
                              />
                              <Input
                                placeholder="양"
                                value={info.nutritional_amount}
                                onChange={(e) => {
                                  let value = e.target.value;

                                  // 숫자와 최대 소수점 1자리까지만 허용하는 정규식
                                  if (/^\d*\.?\d{0,1}$/.test(value)) {
                                    // 값이 비어있으면 0으로 설정
                                    value = value === '' ? '0' : value;
                                    onNuritionalChange(
                                      'update',
                                      { nutritional_amount: value },
                                      index
                                    );
                                  }
                                }}
                                style={{ width: '30%', marginRight: '5px' }}
                              />
                              <Select
                                placeholder="단위"
                                value={info.nutritional_type}
                                onChange={(value) =>
                                  onNuritionalChange(
                                    'update',
                                    { nutritional_type: value },
                                    index
                                  )
                                }
                                options={[
                                  { label: 'mg', value: 'mg' },
                                  { label: 'kcal', value: 'kcal' },
                                  { label: 'g', value: 'g' },
                                ]}
                                style={{ width: '30%' }}
                              />
                              <Button
                                type="danger"
                                style={{ marginLeft: '5px' }}
                                onClick={() =>
                                  onNuritionalChange('remove', {}, index)
                                }
                              >
                                X
                              </Button>
                            </div>
                          ))}

                          <Button
                            type="primary"
                            style={{ width: '100%' }}
                            onClick={() => onNuritionalChange('add')}
                          >
                            영양 정보 추가
                          </Button>
                        </div>
                      ),
                    },
                    {
                      key: 'allergen_ingredient',
                      label: '알레르기 유발 성분',
                      span: 2,
                      children: (
                        <Input
                          size="large"
                          placeholder="알레르기 유발 성분을 입력해주세요 (예: 땅콩/우유/난류)"
                          value={modalData?.menu?.allergen_ingredient}
                          onChange={(e) =>
                            onChange(
                              'allergen_ingredient',
                              e.target.value,
                              'menu'
                            )
                          }
                        />
                      ),
                    },
                    {
                      key: 'exchange_return_policy',
                      label: '교환/반품 안내',
                      span: 2,
                      children: (
                        <Input.TextArea
                          size="large"
                          placeholder="교환/반품 안내를 입력해주세요 (예: 해당 제품은 교환/환불이 불가합니다.)"
                          count={{
                            show: true,
                            max: 200,
                          }}
                          style={{ minHeight: 78 }}
                          value={modalData?.menu?.exchange_return_policy}
                          onChange={(e) =>
                            onChange(
                              'exchange_return_policy',
                              e.target.value,
                              'menu'
                            )
                          }
                        />
                      ),
                    },
                    {
                      key: 'is_present',
                      label: '선물 가능 여부',
                      children: (
                        <Radio.Group
                          options={[
                            { label: '가능', value: 'Y' },
                            { label: '불가능', value: 'N' },
                          ]}
                          onChange={(e) =>
                            onChange('is_present', e.target.value, 'menu')
                          }
                          value={modalData?.menu?.is_present}
                          optionType="button"
                          buttonStyle="solid"
                        />
                      ),
                      span: 2,
                    },
                    // [추가] 선물 관련 정보 (유효기간, 최대 연장 횟수)
                    {
                      key: 'present_information',
                      label: '선물 관련 정보',
                      children: (
                        <div style={{ display: 'flex', gap: '8px' }}>
                          <Input
                            size="large"
                            placeholder="유효기간 (일)"
                            value={
                              modalData?.menu?.present_information
                                ?.present_expired_date ?? ''
                            }
                            onChange={(e) => {
                              const val = parseInt(e.target.value, 10);
                              // 기존 present_information 객체를 복사하여 present_expired_date 갱신
                              onChange(
                                'present_information',
                                {
                                  ...modalData?.menu?.present_information,
                                  present_expired_date: isNaN(val) ? '' : val,
                                },
                                'menu'
                              );
                            }}
                            disabled={modalData?.menu?.is_present === 'N'}
                          />
                          <Input
                            size="large"
                            placeholder="최대 연장 횟수"
                            value={
                              modalData?.menu?.present_information
                                ?.present_postponed_deadline ?? ''
                            }
                            onChange={(e) => {
                              const val = parseInt(e.target.value, 10);
                              onChange(
                                'present_information',
                                {
                                  ...modalData?.menu?.present_information,
                                  present_postponed_deadline: isNaN(val)
                                    ? ''
                                    : val,
                                },
                                'menu'
                              );
                            }}
                            disabled={modalData?.menu?.is_present === 'N'}
                          />
                        </div>
                      ),
                      span: 2,
                    },
                    {
                      key: 'thumbnail',
                      label: '메뉴 썸네일',
                      style: { padding: '10px 20px' },
                      children: (
                        <UploadFile
                          files={thumbnailFiles}
                          preview
                          multiple
                          max={1}
                          onChange={onThumbnailFileChange}
                        />
                      ),
                      span: 2,
                    },
                    {
                      key: 'menu_files',
                      label: '이미지',
                      span: 2,
                      children: (
                        <div style={{ padding: '20px 0px', display: 'flex' }}>
                          <UploadFile
                            files={files}
                            preview
                            multiple
                            max={5}
                            onChange={onFileChange}
                          />
                        </div>
                      ),
                    },
                    {
                      key: 'temperature_option',
                      label: '온도 옵션',
                      span: 2,
                      children: (
                        <Radio.Group
                          options={[
                            { label: 'HOT / ICE', value: 'ALL' },
                            { label: 'HOT ONLY', value: 'HOT' },
                            { label: 'ICE ONLY', value: 'ICE' },
                            { label: 'OTHER', value: 'OTHER' },
                          ]}
                          onChange={(e) =>
                            onChange(
                              'temperature_option',
                              e.target.value,
                              'menu'
                            )
                          }
                          value={modalData?.menu?.temperature_option}
                          optionType="button"
                          buttonStyle="solid"
                          disabled={
                            modalData?.menu?.type === 'MD' ||
                            modalData?.menu?.type === 'DESSERT'
                          }
                        />
                      ),
                    },
                    {
                      key: 'menu_option',
                      label: '옵션',
                      span: 2,
                      children: (
                        <div style={{ padding: '20px 0px' }}>
                          {options?.map((_item, _index) => (
                            <OptionForm
                              key={`option_form_${_index}`}
                              data={_item}
                              onChange={(d) => onOptionChange(d, _index)}
                              onRemove={() =>
                                onOptionList((prev) =>
                                  prev.filter((_, i) => _index !== i)
                                )
                              }
                            />
                          ))}
                          <div>
                            <Button
                              type="primary"
                              style={{ width: '100%' }}
                              onClick={() =>
                                // onOptionList((prev) => [...prev, optionTemp])
                                onOptionList((prevOptions) => [
                                  ...prevOptions,
                                  {
                                    ...optionTemp,
                                    option_id: prevOptions.length + 1, // 배열 길이에 기반하여 임시 option_id 생성
                                  },
                                ])
                              }
                            >
                              옵션 등록
                            </Button>
                          </div>
                        </div>
                      ),
                    },
                  ]}
                />
              </Content>
            </Col>
          </Row>
        </Content>
      </ModalLayout>
    </>
  );
};

export default MenuManagementPresenter;
